import React from "react";
import centerImage from "../Store/media/images/tycoonland_header_image.jpeg";
import appStoreIcon from "../Store/media/icons/AppStore.svg";
import { 
  FaTelegram, 
  FaDiscord, 
  FaXTwitter, 
  FaFacebook, 
  FaTiktok, 
  FaInstagram, 
  FaReddit 
} from "react-icons/fa6";
import "./MenuScreen.css";
import MenuButton from '../Store/MenuButton';

const MenuScreen: React.FC = () => {

  const formatPrice = (price: number | null) => {
    if (price === null) return 'N/A';
    return price < 0.01 ? price.toFixed(6) : price.toFixed(4);
  };

  const formatPriceChange = (change: number | null) => {
    if (change === null) return 'N/A';
    const sign = change >= 0 ? '+' : '';
    return `${sign}${change.toFixed(2)}%`;
  };

  const handleRefreshPrice = () => {
    window.location.reload(); // Simple refresh for now
  };

  return (
    <div className="menu-screen">
      <MenuButton />

      <div className="center-content">
       
        <img
          src={centerImage}
          alt="Tycoonland Header"
          className="main-image"
        />

        <a
          href="https://apps.apple.com/us/app/tycoonland/id6449153712?platform=iphone"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={appStoreIcon}
            alt="Download on App Store"
            className="example-image clickable-icon"
          />
        </a>

        <div className="social-media-section">
          <a 
            href="https://t.me/tycoonlandcommunity" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaTelegram className="social-icon" data-icon="FaTelegram" />
            <span className="social-text">Telegram</span>
          </a>
          <a 
            href="https://discord.gg/B3GnyVr9J" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaDiscord className="social-icon" data-icon="FaDiscord" />
            <span className="social-text">Discord</span>
          </a>
          <a 
            href="https://x.com/tycoonland?s=21" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaXTwitter className="social-icon" data-icon="FaXTwitter" />
            <span className="social-text">X</span>
          </a>
          <a 
            href="https://www.facebook.com/profile.php?id=61578329717209&mibextid=wwXIfr&mibextid=wwXIfr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaFacebook className="social-icon" data-icon="FaFacebook" />
            <span className="social-text">Facebook</span>
          </a>
          <a 
            href="https://www.instagram.com/tycoonland.nyc?igsh=NTc4MTIwNjQ2YQ==" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaInstagram className="social-icon" data-icon="FaInstagram" />
            <span className="social-text">Instagram</span>
          </a>
          <a 
            href="https://www.tiktok.com/@tycoonland.nyc?_t=ZT-8yR819iWt9a&_r=1" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaTiktok className="social-icon" data-icon="FaTiktok" />
            <span className="social-text">TikTok</span>
          </a>
           

         <a 
            href="https://www.reddit.com/u/Tycoonland/s/4RxKtKrn3p" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-media-item"
          >
            <FaReddit className="social-icon" data-icon="FaReddit" />
            <span className="social-text">Reddit</span>
          </a>

        </div>

        <a
          href="https://www.tycoonland.nyc/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="menuscreen-text menuscreen-link"
        >
          Privacy & Terms of Service
        </a>
      </div>

      <div className="footer-text">
        ©2025 Conglomerator & Co.
      </div>
    </div>
  );
};

export default MenuScreen;
